import React, { useEffect, useState } from "react";
import ThemedLoader from 'components/atoms/ThemedLoader'
import i18n from "utils/i18n";
import HelperString from 'utils/helper-string'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import { constantsActive } from 'utils/constants/constants'
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import _ from 'lodash'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import Translate from 'utils/translate'
import { listArrow } from 'styles/list'
import FetchTimeslotKinds from 'utils/fetch/FetchTimeslotKinds'
import TimeslotIcon from 'components/molecules/TimeslotIcon'
import { StyleSheet, View } from 'react-native'
import { AppRoutes } from 'navigations/app-routes'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { timeslotKindConstants } from 'utils/constants/timeslot-kind-constants'
import ListItem from 'components/atoms/ListItem'


const ManagementTimeslotsIndexTabTimeslotKinds = () => {
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	
	const [ timeslotkinds, setTimeslotKinds ] = useState( [] );
	const [ isLoading, setIsLoading ] = useState( false );
	const [ search, setSearch ] = useState('')
	
	const loading = () => {
		setIsLoading(true);
	}
	const loaded = () => {
		setIsLoading(false);
	}
	
	const fetchedTimeslotKinds = ( timeslotKinds ) => {
		timeslotKinds = _.orderBy( timeslotKinds, ( o ) => {
			switch( o?.kind ){
				case timeslotKindConstants.BOOKING:
					return 1;
				case timeslotKindConstants.LUNCH:
					return 2;
				case timeslotKindConstants.TRANSPORT:
					return 3;
				case timeslotKindConstants.MEETING_ROOM:
					return 4;
				case timeslotKindConstants.CUSTOM:
					return 5;
			}
		} );
		
		setTimeslotKinds( timeslotKinds );
		loaded();
	}
	
	const fetchTimeslotKinds = () => {
		if( !isLoading ){
			FetchTimeslotKinds.fetchAll({
				callbackStart: loading,
				callbackError: loaded,
				callbackSuccess: fetchedTimeslotKinds
			});
		}
	}
	
	useEffect( () => {
		fetchTimeslotKinds();
	}, [] );
	
	useEffect( () => {
		if( isFocused ) {
			fetchTimeslotKinds();
		}
	}, [ isFocused ] );
	
	const openTimeslotKind =  ( timeslotKind ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_TIMESLOT_KINDS, {
			timeslotKindGuid: timeslotKind.guid
		});
	}
	
	const createTimeslotKind = () => {
		navigation.navigate( AppRoutes.MANAGEMENT_TIMESLOT_KINDS_ADD, {} );
	}
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ Translate.field( item, 'name' ) }
				title_add_active_tag={ true }
				item={ item }
				accessoryLeft={ <View style={ staticStyles.viewWidth45Height45 }><TimeslotIcon timeslot={ item } /></View> }
				accessoryLeftSize={ 60 }
				accessoryRight={ listArrow }
				onPress={ openTimeslotKind }
			/>
		)
	}
	
	const header = (
		<ManagementHeader
			inputs={[
				{
					placeholder: i18n.t( 'management:form.search.title'),
					onChangeText: _.debounce( setSearch, 400 )
				}
			]}
			addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TEAMS ) ? { onPress: createTimeslotKind } : null }
		/>
	);
	
	const content = [];
	
	const filters = _.size( search ) > 2 ? [ {field: 'name', kind: 'contains', value: search } ] : null;
	
	switch( true ) {
		case isLoading:
			content.push(
				<ThemedLoader
					key={ HelperString.hash('coworker-tab-coworker-loading-members') }
					text={ i18n.t( 'loading.timeslot_kinds' ) }
				/>
			);
			break;
		
		default:
			content.push(
				<ManagementGroupedThemeList
					header={ header }
					items={ timeslotkinds }
					renderItem={ renderItem.bind( this ) }
					groupByKey={ 'active' }
					filters={ filters }
					groupByValues={ [
						constantsActive.YES,
						constantsActive.NO
					] }
				/>
			);
	}
	
	return content
}

const staticStyles = StyleSheet.create({
	viewWidth45Height45: {
		width: 45,
		height: 45,
		marginRight: 5,
	},
});

export default ManagementTimeslotsIndexTabTimeslotKinds;
